<template>
  <a-form
    class="mod-form"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item label="新密码">
      <a-input
        size="large"
        placeholder="请输入8-15位数字和字母组合的新密码"
        type="password"
        v-decorator="[
          'password',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="确认密码">
      <a-input
        size="large"
        placeholder="请再次输入新密码"
        type="password"
        v-decorator="[
          'confirmPassword',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
      </user-slider-captcha>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
import { settingPassword } from '@/api/member'

export default {
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      token: '',
      loading: false
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('password-setting', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          try {
            const { token } = this

            if (!token) {
              this.$error({
                content: '请拖动滑块完成验证！',
                centered: true
              })
              return
            }

            this.loading = true

            await settingPassword({
              newPass: values.password,
              sliderCaptCha: token
            })

            this.$success({
              content: '设置密码成功，请重新登录！',
              centered: true,
              onOk: () => {
                this.$router.replace({
                  path: '/login',
                  query: {
                    __done__: '/micro/user/account'
                  }
                })
              }
            })
          } catch (err) {
            this.$refs.verify.refresh()
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
          }
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
    }
  }
}
</script>
